import { Typography } from "antd";

const { Text } = Typography;
const copyrightText = "STELAR.AI ©";

export const AppCopyright = () => (
  <Text>
    {copyrightText} {new Date().getFullYear()}
  </Text>
);
